/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Access_DeniedInputs */



/**
* | output |
* | --- |
* | "Sign-in was cancelled." |
*
* @param {Login_Access_DeniedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_access_denied = /** @type {((inputs?: Login_Access_DeniedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Access_DeniedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Aanmelden is geannuleerd.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La connexion a été annulée.")
	return /** @type {LocalizedString} */ ("Sign-in was cancelled.")
});